import React, { useState, useCallback, useEffect,useMemo } from "react";
import useStyles from "./style";
import { Button, Grid, Typography, TextField , Box  } from "@mui/material";
import {EditOutlined ,DeleteOutline } from "@mui/icons-material";
import { DataGrid , GridToolbar } from "@mui/x-data-grid";
import * as XLSX from "xlsx";
import Papa from "papaparse";
import jsPDF from "jspdf";
import "jspdf-autotable";

import { showLoader, hideLoader } from "Redux/Loader/actions";
import { showSnackbar } from "Redux/SnackBar/actions";
import { useDispatch } from "react-redux";
import _ from "lodash";
import { useFormik } from "formik";
import Pagination from "@mui/material/Pagination";

//Services
import servicetypeapi from "Services/Servicefare";

//Modals
import ServicetypeAddModal from "Pages/Modals/Servicetypefare/Create";
import ServicetypeUpdateModal from "Pages/Modals/Servicetypefare/Update";
import ServicetypeDeleteDialog from "Pages/Modals/Servicetypefare/Delete";

const Servicetype = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  //

  const [row, setRow] = useState([]);
  const [servicefarerow, servicefaresetRow] = useState([]);
  const [customerId, setCustomerId] = useState("");

  //Pagination

  const [page, setPage] = useState(1); // Initial page number
  const [pageSize, setPageSize] = useState(5); // Initial page size
  const [totalPages, setTotalPages] = useState(1);
  

  //Modals

  const [addServicetypeModal, setaddServicetypeModal] = useState(false);

  const handleOpenAddServiceModal = () => {
    setaddServicetypeModal(true);
  };

  const handleCloseAddServiceModal = () => {
    setaddServicetypeModal(false);
    getServicetype();
  };

  const [updateServicetypeModal, setupdateServicetypeModal] = useState(false);

  const handleOpenUpdateServiceModal = (row) => {
    setCustomerId(row?._id);
    setupdateServicetypeModal(true);
  };

  const handleCloseUpdateServiceModal = () => {
    setupdateServicetypeModal(false);
    getServicetype();
  };
  
  const [deleteServicetypeModal, setdeleteServicetypeModal] = useState(false);

  const handleOpenDeleteServiceModal = (row) => {
    setCustomerId(row?._id);
    setdeleteServicetypeModal(true);
  };

  const handleCloseDeleteServiceModal = (row) => {
    setdeleteServicetypeModal(false);
    getServicetype();
  };

  // Get Services list api
  const getServicetype = useCallback(() => {
    dispatch(showLoader("Loading please wait..."));
    const onSuccess = (res) => {
      console.log('servicetyperes.data--->',res.data);
      dispatch(hideLoader());
      if (res?.data?.status === true) {
        setTotalPages(res?.data?.data?.totalRecords || 1);
        setRow(res?.data?.data?.data);
        servicefaresetRow(res?.data?.data?.serviceFaresdata);
      } else {
        setRow([]);
        servicefaresetRow([]);
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Failed to fetch data",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
      //console.log("error fetch service area", err);
    };
    servicetypeapi.getServicesList({ page, limit: pageSize })
      .then(onSuccess, onFailure);
  }, [page, pageSize]);

  useEffect(() => {
    getServicetype();
  }, [getServicetype]);

  const serviceFareStatusMap = useMemo(() => {
    const map = {};
    (servicefarerow || []).forEach(fare => {
      map[fare?.serviceTypeId] = fare?.isActive;
    });
    return map;
  }, [servicefarerow]);

  const handleCopy = () => {

       // Define column widths
       const columnWidths = [5, 15 , 15 ]; // Adjust widths as needed
  
       // Helper function to pad text to the desired width
       const padText = (text, width) => {
         return (text ?? "").toString().padEnd(width, " ");
       };
       // Create table header
       const header = [
         padText("S.NO", columnWidths[0]),
         padText("SERVICE TYPE", columnWidths[1]),
         padText("SERVICE STATUS", columnWidths[2]),
       ].join("");
     
       // Create table rows
       const rows = dataRows
         .map((row) =>
           [
             padText(row.sno, columnWidths[0]),
             padText(row.serviceType, columnWidths[1]),
             padText(row.status?"Active":"Inactive", columnWidths[2]),
           ].join("")
         )
         .join("\n");
     
       // Combine header and rows
       const formattedContent = [header, rows].join("\n");
     
       // Copy to clipboard
       navigator.clipboard.writeText(formattedContent).then(() => {
         alert("Table copied to clipboard!");
       });
  };

  const handleDownloadExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(formatteddatas);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Services");
    XLSX.writeFile(workbook, "ServiceList.xlsx");
  };

  const handleDownloadCSV = () => {
    const csv = Papa.unparse(formatteddatas);
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "ServiceList.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleDownloadPDF = () => {
    const doc = new jsPDF();
    const tableData = dataRows.map((row) => [
      row.sno,
      row.serviceType,
      row.status?"Active":"Inactive",
    ]);
    doc.autoTable({
      head: [["S.No", "Service Type" , "Status"]],
      body: tableData,
    });
    doc.save("ServiceList.pdf");
  };

  const handlePageChange = (newPage) => {
    let theNewPage = parseInt(newPage) + 1;
    if (theNewPage >= 1) {
      setPage(theNewPage);
    }
  };

  const calculateSno = (pageIndex, pageSize, index) => {
    return (pageIndex - 1) * pageSize + index + 1;
  };

 const dataRows = useMemo(() => {
    return _.map(row || [], (data, index) => ({
      sno: calculateSno(page, pageSize, index),
      serviceImage: data?.serviceImage,
      serviceType: data?.serviceName,

      // ✅ status from serviceFareModel
      status: serviceFareStatusMap[data?._id] ?? false,

      row: data,
    }));
  }, [row, page, pageSize, serviceFareStatusMap]);

  const formatteddatas = dataRows.map((row) => ({
    "S.NO": row.sno,
    "SERVICE TYPE": row.serviceType,
    "STATUS": row.status ? "Active":"Inactive",
  }));
  
  const columns = [
    {
      field: "sno",
      headerName: "S.No",
      flex:0.5,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        return (
          <>
            <div className={classes.lightText}>
              <Typography variant="body2">{params?.row?.sno}</Typography>
            </div>
          </>
        );
      },
    },
    {
      field: "serviceImage",
      headerName: "Service Image",
      flex:1,
      sortable: true,
      renderCell: (params) => {
        return (
          <>
<div>
                  <Box
                  component="img"
                  sx={{
                  width: 50,
                  height: 50,
                  borderRadius: "25%",
                  objectFit: "cover",
                  boxShadow: 3,
                  }}
                  src={params?.row?.serviceImage}
                  alt="Sample Image"
                  />
</div>
          </>
        );
      },
    },
    {
      field: "serviceType",
      headerName: "Service Type",
      flex:1,
      sortable: true,
      renderCell: (params) => {
        return (
          <>
            <div>
              <Typography variant="body2">{params?.row?.serviceType}</Typography>
            </div>
          </>
        );
      },
    },
    {
      field: "status",
      headerName: "Status",
      flex:1,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        return (
          <> 
          <Button variant="contained">{params?.row?.status ? "active":"inactive"}</Button>          
          </>
        );
      },
    },
    {
      field: "actions",
      headerName: "Actions",
      flex:1,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        return (
          <>
            <div className={classes.iconsWrapper}>
              <section className={classes.editIcon}>
                <EditOutlined
                  onClick={() =>
                    handleOpenUpdateServiceModal(params?.row?.row)
                  }
                />
                  <Typography variant="subtitle2" gutterBottom className={classes.actiontypo}>
                    Edit
                   </Typography>
              </section>
              <section className={classes.deleteIcon}>
                <DeleteOutline
                  onClick={() =>
                    handleOpenDeleteServiceModal(params?.row?.row)
                  }
                />
                <Typography variant="subtitle2" gutterBottom className={classes.actiontypo}>
                    Delete
                   </Typography>
              </section>
            </div>
          </>
        );
      },
    },
  ];

  return (
    <>
      <Grid container className={classes.root}>
      {/* <Grid item xs={1} md={1} lg={1} xl={1} className={classes.funBtn}>
          <Button variant="contained" onClick={handleCopy}>
            COPY
          </Button>
        </Grid>
        <Grid item xs={1} md={1} lg={1} xl={1} className={classes.funBtn}>
          <Button variant="contained" onClick={handleDownloadExcel}>
            EXCEL
          </Button>
        </Grid>
        <Grid item xs={1} md={1} lg={1} xl={1} className={classes.funBtn}>
          <Button variant="contained" onClick={handleDownloadCSV}>
            CSV
          </Button>
        </Grid>
        <Grid item xs={1} md={1} lg={1} xl={1} className={classes.funBtn}>
          <Button variant="contained" onClick={handleDownloadPDF}>
            PDF
          </Button>
        </Grid> */}
        <Grid item xs={8} md={8} lg={8} xl={8} className={classes.funBtn}>
          <Button variant="contained" onClick={handleOpenAddServiceModal}>
            Add Fare Model
          </Button>
        </Grid>
        <Grid item xs={12} >
          <section  className={classes.dataGridTable}>
            <DataGrid
              getRowId={(row) => row?.row?._id}
              rows={dataRows}
              columns={columns}
              pageSize={pageSize}
              onPageSizeChange={(newPageSize) => {
                setPageSize(newPageSize);
                setPage(1);
              }}
              onPageChange={(newPage) => handlePageChange(newPage)}
              rowsPerPageOptions={[5, 10, 25, 50]}
              pagination
              autoHeight={true}
              disableSelectionOnClick
              scrollbarSize={4}
              rowHeight={70}
              style={{ padding: "10px", borderRadius: "0px" }}
              paginationMode="server"
              rowCount={totalPages}
              columnResizeMode="onDrag" // Allows resizing
              disableColumnFilter
              disableColumnSelector
              disableDensitySelector
              slots={{ toolbar: GridToolbar }}
              slotProps={{
                toolbar: {
                  showQuickFilter: true,
                },
              }}
            />
          </section>
        </Grid>
      </Grid>
      <ServicetypeAddModal
        openDialog={addServicetypeModal}
        handleClose={handleCloseAddServiceModal}
      ></ServicetypeAddModal>
      <ServicetypeUpdateModal
        openDialog={updateServicetypeModal}
        id={customerId}
        handleClose={handleCloseUpdateServiceModal}
      ></ServicetypeUpdateModal>
      <ServicetypeDeleteDialog
        openDialog={deleteServicetypeModal}
        id={customerId}
        handleClose={handleCloseDeleteServiceModal}
      ></ServicetypeDeleteDialog>
    </>
  );
};

export default Servicetype;
